// Shared colour palette for the home dashboard charts. Categorical series cycle through PALETTE;
// status series use the fixed STATUS_COLORS so Success/Warning/Failed read consistently everywhere.

export const PALETTE: { bg: string; border: string }[] = [
  { bg: "#bfdbfe", border: "#1d4ed8" }, // blue
  { bg: "#fde68a", border: "#d97706" }, // amber
  { bg: "#bbf7d0", border: "#166534" }, // green
  { bg: "#a5f3fc", border: "#0891b2" }, // cyan
  { bg: "#fecaca", border: "#dc2626" }, // red
  { bg: "#e2e8f0", border: "#64748b" }, // slate
  { bg: "#ddd6fe", border: "#7c3aed" }, // violet
  { bg: "#fbcfe8", border: "#db2777" }, // pink
];

export function paletteAt(index: number) {
  return PALETTE[index % PALETTE.length];
}

export const STATUS_COLORS = {
  success: { bg: "#bbf7d0", border: "#166534" },
  warning: { bg: "#fde68a", border: "#d97706" },
  failed: { bg: "#fecaca", border: "#dc2626" },
} as const;
